import { ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import Controller, { OnCatch, OnMount, OnSuccess, OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { RequestEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { HttpError } from '@philips-internal/oswald-ui-core/lib/services/http-service';
import { LoginAPI } from '@philips-internal/oswald-ui-foundation';

import checkAssignTerms from '../../../utils/check-assign-terms';
import BaseController from '../../BaseController';

interface RequestEventLogin {
  preventDefault: () => void;
}

interface Resp {
  [key: string]: string;
}

@Controller({ component: 'panel-login', fragment: 'login' })
export default class LoginControler extends BaseController {

  @OnMount({ target: 'panel-login' })
  onMountLogin(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.BRIGHT);
  }

  @OnUnmount({ target: 'panel-login' })
  onUnmount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
  }

  @OnCatch({ target: 'login' })
  onCatch(event: RequestEvent<Error | Record<string, unknown>>): void {
    const api = event.target as unknown as LoginAPI;
    const error = event.response as unknown as HttpError;

    if (error.response) {
      const contentType = error.response.headers?.get('content-type');

      if (contentType?.includes('application/json')) {
        error.response.json().then((resp: Resp) => {
          api.setNotification({
            highlight: true,
            level: ToastLevel.ERROR,
            message: this.getErrorMessage(resp),
            title: '',
          });
        }).catch(() => {
          this.showGenericError(api);
        });
      } else {
        this.showGenericError(api);
      }
    } else {
      this.showGenericError(api);
    }
  }

  private showGenericError(api: LoginAPI): void {
    api.setNotification({
      highlight: true,
      level: ToastLevel.ERROR,
      message: MessageService.translate('login-message.connection-error'),
      title: MessageService.translate('approval.error'),
    });
  }

  getErrorMessage(resp: Resp): string {
    return Object.keys(resp).filter(item => item !== '1').reduce((ret, value) => `${ret} ${MessageService.translate(resp[value])}`, '');
  }

  @OnSuccess({ target: 'login' })
  onSuccess(event: RequestEventLogin): void {
    if (!event.preventDefault) {
      return;
    }
    event.preventDefault();
    checkAssignTerms();
  }
}
